function copyListenerFunc(){
    const copyListener = (event) => {
        const range = window.getSelection().getRangeAt(0),
            rangeContents = range.cloneContents(),
            pageLink = `Подробнее: ${document.location.href}`,
            helper = document.createElement("div");

        if (range.toString().split(' ').length < 10) {
            return;
        }

        helper.appendChild(rangeContents);
        event.clipboardData.setData("text/plain", `${helper.innerText}\n${pageLink}`);
        event.clipboardData.setData("text/html", `${helper.innerHTML}<br>${pageLink}`);
        event.preventDefault();
    };
    document.addEventListener("copy", copyListener);
}
export default copyListenerFunc;